import { HighwaysContainer } from '../HighwaysContainer';
import { UndergroundsContainer } from '../UndergroundsContainer';

export function GeoContainer() {
  return (
    <>
      <UndergroundsContainer />
      <HighwaysContainer />
    </>
  );
}
